<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="技术人员登记信息变更" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="变更表编号">
                                        <a-input ref="bgsqbbh" v-model="editData.bgsqbbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="变更日期" required>
                                        <a-date-picker ref="bgrq" v-model="editData.bgrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="姓名" required>
                                        <a-input-search ref="xm" readOnly @search="isShow_xm = true" v-model="editData.xm" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_xm"
                                            selectNo="RY1001"
                                            :condition="selStaticCondition"
                                            @saveselect="saveEvent_xm(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="性别">
                                        <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="民族">
                                        <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="editData.mz" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="出生日期">
                                        <a-date-picker ref="csrq" v-model="editData.csrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="证件类型">
                                        <FGDictSelectCN ref="zjlx" dictNo="RY100104" v-model="editData.zjlx" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="证件号码">
                                        <a-input ref="zjhm" v-model="editData.zjhm" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所属单位编号">
                                        <a-input ref="ssdwbh" v-model="editData.ssdwbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所属单位名称">
                                        <a-input ref="ssdwmc" v-model="editData.ssdwmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="区域编号">
                                        <a-input ref="qybh" v-model="editData.qybh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="区域名称">
                                        <a-input ref="qymc" v-model="editData.qymc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="人员类别">
                                        <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="editData.rylb" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职务">
                                        <a-input ref="zw" v-model="editData.zw" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职称">
                                        <FGDictSelectCN ref="zc" dictNo="RY100109" v-model="editData.zc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职称专业">
                                        <a-input ref="zczy" v-model="editData.zczy" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="批准时间">
                                        <a-date-picker ref="pzsj" v-model="editData.pzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="毕业院校">
                                        <a-input ref="byyx" v-model="editData.byyx" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="毕业时间">
                                        <a-date-picker ref="bysj" v-model="editData.bysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所学专业">
                                        <a-input ref="sxzy" v-model="editData.sxzy" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="学历">
                                        <FGDictSelectCN ref="xl" dictNo="RY100106" v-model="editData.xl" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="学位">
                                        <FGDictSelectCN ref="xw" dictNo="RY100107" v-model="editData.xw" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="参加工作时间">
                                        <a-date-picker ref="cjgzsj" v-model="editData.cjgzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="从业时间">
                                        <a-date-picker ref="cysj" v-model="editData.cysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="固定电话">
                                        <a-input ref="gddh" v-model="editData.gddh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="移动电话">
                                        <a-input ref="yddh" v-model="editData.yddh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="个人简历">
                                        <a-input ref="grjl" v-model="editData.grjl" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="上岗证编号">
                                        <a-input ref="sgzbh" v-model="editData.sgzbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="登记状态" required>
                                        <FGDictSelectCN ref="zczt" dictNo="RY100108" v-model="editData.zczt" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="资格证书编号" required>
                                        <a-input ref="zyzgzsbh" v-model="editData.zyzgzsbh" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="登记单位编号">
                                        <a-input ref="zcdwbh" v-model="editData.zcdwbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="登记单位名称">
                                        <a-input ref="zcdwmc" v-model="editData.zcdwmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="登记时间" required>
                                        <a-date-picker ref="zcsj" v-model="editData.zcsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="登记周期(年)">
                                        <a-input-number ref="zczq" v-model="editData.zczq" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="首次登记时间">
                                        <a-date-picker
                                            ref="sczcsj"
                                            v-model="editData.sczcsj"
                                            valueFormat="YYYY-MM-DD"
                                            style="width:100%"
                                            @change="onChange(editData.sczcsj)"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="下次登记时间">
                                        <a-date-picker
                                            ref="xczcsj"
                                            v-model="editData.xczcsj"
                                            valueFormat="YYYY-MM-DD"
                                            style="width:100%"
                                            disabled
                                            placeholder=""
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="登记证编号" required>
                                        <a-input ref="zczbh" v-model="editData.zczbh" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="主专业" required>
                                        <a-input-search ref="zzy" readOnly @search="isShow_zzy = true" v-model="editData.zzy" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_zzy"
                                            selectNo="RY200601"
                                            @saveselect="saveEvent_zzy(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="辅专业">
                                        <a-input-search ref="fzy" readOnly @search="visibleFzy" v-model="editData.fzy" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_fzy"
                                            selectNo="RY200601"
                                            @saveselect="saveEvent_fzy(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="变更说明" required>
                                        <a-input ref="bgsm" v-model="editData.bgsm" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入部门">
                                        <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入人">
                                        <a-input ref="lrr" v-model="editData.lrr" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入时间">
                                        <a-input ref="lrrq" v-model="editData.lrrq" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="备注">
                                        <a-input ref="bz" v-model="editData.bz" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "JsryzcxxbgEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isnew: true,
            tableData: [],
            isShow_qybh: false,
            isShow_xm: false,
            selStaticCondition: "",
            isShow_qymc: false,
            isShow_ssdwbh: false,
            isShow_ssdwmc: false,
            isShow_zcdwbh: false,
            isShow_zcdwmc: false,
            isShow_fzy: false,
            isShow_zzy: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "RY_BGSQB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "RY3005"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                bglx: "注册信息变更",
                bgsqbbh: "",
                bgrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                djlxid: "BGSQB",
                bmid: this.getUserInfo.org_id,
                ryid: this.getUserInfo.personnel_id,
                yhid: this.getUserInfo.id,
                lrbmmc: this.getUserInfo.org_name,
                lrr: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                djzt: "制定",
                zcsj: null,
                sczcsj: null,
                xczcsj: null,
                zczt: null
            };
            this.tableData = [];
            this.submitShow = false;
            this.$FG_helper.handleNewBillCode("BGSQBBH").then((val) => {
                this.editData.bgsqbbh = val;
            });
        } else {
            this.submitShow = true;
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.bgsqbbh.focus();
        });
    },
    mounted() {
        this.selStaticCondition = " AND SSDWID='" + this.getUserInfo.companyInfo.id + "' ";
    },
    methods: {
        saveEvent_xm(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.jsryid = val[0][0].ID;
                this.editData.xm = val[0][0].XM;
                this.editData.xb = val[0][0].XB;
                this.editData.mz = val[0][0].MZ;
                this.editData.csrq = val[0][0].CSRQ;
                this.editData.zjlx = val[0][0].ZJLX;
                this.editData.zjhm = val[0][0].ZJHM;
                this.editData.ssdwid = val[0][0].SSDWID;
                this.editData.ssdwbh = val[0][0].SSDWBH;
                this.editData.ssdwmc = val[0][0].SSDWMC;
                this.editData.qyid = val[0][0].QYID;
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.rylb = val[0][0].RYLB;
                this.editData.zw = val[0][0].ZW;
                this.editData.zc = val[0][0].ZC;
                this.editData.zczy = val[0][0].ZCZY;
                this.editData.pzsj = val[0][0].PZSJ;
                this.editData.byyx = val[0][0].BYYX;
                this.editData.bysj = val[0][0].BYSJ;
                this.editData.sxzy = val[0][0].SXZY;
                this.editData.xl = val[0][0].XL;
                this.editData.xw = val[0][0].XW;
                this.editData.cjgzsj = val[0][0].CJGZSJ;
                this.editData.cysj = val[0][0].CYSJ;
                this.editData.gddh = val[0][0].GDDH;
                this.editData.yddh = val[0][0].YDDH;
                this.editData.grjl = val[0][0].GRJL;
                this.editData.sgzbh = val[0][0].SGZBH;
                this.editData.zczt = val[0][0].ZCZT;
                this.editData.zyzgzsbh = val[0][0].ZYZGZSBH;
                this.editData.zcdwid = val[0][0].ZCDWID;
                this.editData.zcdwbh = val[0][0].ZCDWBH;
                this.editData.zcdwmc = val[0][0].ZCDWMC;
                this.editData.zcsj = val[0][0].ZCSJ;
                this.editData.xczcsj = val[0][0].XCZCSJ;
                this.editData.zczbh = val[0][0].ZCZBH;
                this.editData.zzy = val[0][0].ZZY;
                this.editData.fzy = val[0][0].FZY;
                this.editData.sczcsj = val[0][0].SCZCSJ;
                this.editData.zczq = 3;
            }
        },
        visibleFzy() {
            this.isShow_fzy = true;
            this.editData.fzy = null;
        },
        saveEvent_zzy(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.zzy = val[0][0].ZYMC;
            }
        },
        saveEvent_fzy(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.fzy = val[0][0].ZYMC;
            }
        },
        saveEvent_qybh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.qyid = val[0][0].ID;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.qybh = val[0][0].QYBH;
            }
        },
        saveEvent_ssdwbh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.ssdwid = val[0][0].ID;
                this.editData.ssdwbh = val[0][0].DWBH;
                this.editData.ssdwmc = val[0][0].DWMC;
            }
        },
        onChange(e) {
            let d1 = new Date(e).setFullYear(new Date(e).getFullYear() + 3);
            this.editData.xczcsj = this.$FG_util.formatDate(d1, "YYYY-MM-DD");
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzcxxbg/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.bgrq) {
                    this.$FG_message.error("P0001", "变更日期").then(() => this.$refs.bgrq.focus());
                    return;
                }
                if (!this.editData.xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => this.$refs.xm.focus());
                    return;
                }
                if (!this.editData.bgsm) {
                    this.$FG_message.error("P0001", "变更说明").then(() => this.$refs.bgsm.focus());
                    return;
                }
                if (!this.editData.zczt) {
                    this.$FG_message.error("P0001", "登记状态").then(() => this.$refs.zczt.focus());
                    return;
                }
                if (!this.editData.zyzgzsbh) {
                    this.$FG_message.error("P0001", "资格证书编号").then(() => this.$refs.zyzgzsbh.focus());
                    return;
                }

                if (!this.editData.zczbh) {
                    this.$FG_message.error("P0001", "登记证编号").then(() => this.$refs.zczbh.focus());
                    return;
                }
                if (!this.editData.zzy) {
                    this.$FG_message.error("P0001", "主专业").then(() => this.$refs.zzy.focus());
                    return;
                }
                if (!this.editData.zcsj) {
                    this.$FG_message.error("P0001", "登记时间").then(() => this.$refs.zcsj.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzcxxbg/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        this.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.bgsqbbh.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/jsryzcxxbg/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bgsqbbh.focus();
                            }
                        });
                }
            });
        },
        // 新增明细
        insertPXJL() {
            let xh = this.$refs.itemPXJLTable.getInsertRecords().concat(this.$refs.itemPXJLTable.getUpdateRecords()).length + 1;
            // 设置编辑记录
            this.$refs.itemPXJLTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        djsqbid: this.editData.id,
                        xh: xh
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemPXJLTable.setActiveRow(row);
                });
        },
        // 删除明细
        removePXJL(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemZCXXTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/jsry/jsryzcxxbg/deleteMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadItemPXJLData();
                                }
                            });
                    }
                }
            });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        }
    }
};
</script>
